<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
  *{margin: 0;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<script>
export default{
  mounted() {
    document.body.style.zoom=0.9;
  }
}
</script>
